export default "__VITE_ASSET__DaeajhuE__"